//this hook checks that the current user is allowed to view the workshop
import { useSelector } from "react-redux";

const useCanViewWorkshop = () => {
  const user = useSelector((state) => state.workshops.user);
  const { selectedWorkshop } = useSelector((state) => state.workshops);
  const { upcoming, expired } = useSelector(
    (state) => state.workshops.workshops
  );

  //if the user is an admin they can view all workshops
  if (user?.idTokenClaims?.roles.some((role) => role === "Workshops.Admin"))
    return true;

  if (selectedWorkshop === null) return true;

  //check if the current user has the workshop in their list of workshops
  if (upcoming.some((w) => w.workshopId === selectedWorkshop.workshopId))
    return true;

  if (expired.some((w) => w.workshopId === selectedWorkshop.workshopId))
    return true;

  //this workshop id does not exist in the user's workshop list, so they do not have access to it
  return false;
};

export default useCanViewWorkshop;
